import React from 'react';
import {t, withState} from 'shared/core';
import {observer} from 'mobx-react';
import Input from 'shared/components/Input';
import {UploadFiles} from 'main/components';
import ObjectSelect2 from 'shared/components/ObjectSelect2';
import { FormLayout } from 'shared/components/forms';
import LabelHelper from 'shared/components/LabelHelper';
import {ModalButtons} from 'shared/components/modals';
import {DocumentUploadState} from '../state';

const DocumentUpload = observer(({document, accept, onSave, onCancel, uiState}) => {
  const {files, errors, recipientOptions} = uiState;

  return (
    <form>
      <FormLayout>
        <Input
          label='company_settings.documents.Company Document Name'
          errorMessage={errors.name}
          type='text'
          value={document.name}
          onChange={(e) => document.merge({name: e.target.value})}/>
        {document.documentType === 'static_document' &&
          <ObjectSelect2
            value={document.notificationRecipients}
            onAdd={recipient => document.addRecipient(recipient)}
            onRemove={recipient => document.removeRecipient(recipient)}
            items={recipientOptions}
            label='company_settings.documents.Notify on Completion'
            placeholder='company_settings.documents.e.g., Manager'
            by='value'
            multiple
            searchable={true}
          />
        }
        <div>
          <LabelHelper label={t('company_settings.documents.Upload your document')}/>
          <UploadFiles
            defaultFiles={files}
            onChange={(files) => uiState.updateFile(files)}
            onUploadStarted={() => uiState.onUploadStarted()}
            onUploadFinished={() => uiState.onUploadFinished()}
            errorMessage={errors.awsFiles}
            isUploading={uiState.isUploading}
            maxFiles={1}
            accept={accept}
            modelType='onboarding_documents'
          />
        </div>
        <ModalButtons
          onSave={() => onSave()}
          saveEnabled={uiState.canSaveDocument}
          onCancel={() => onCancel()}
        />
      </FormLayout>
    </form>
  );
});

export default withState(DocumentUpload, DocumentUploadState);
